class SunshineToolbars extends HTMLElement {
  connectedCallback() {
    this.onNavState = this.onNavState.bind(this);
    window.addEventListener('sunshine:header-state', this.onNavState);

    // Dawn's own StickyHeader only measures --header-height once on connect (plus on
    // 990px breakpoint crossings) — it never re-measures after later layout shifts
    // (logo image finishing its load, font swap, etc). We stick to `top: var(--header-height)`,
    // so a stale value pins us partway behind the real header instead of just below it.
    // A ResizeObserver keeps the value continuously correct instead of trusting one
    // early snapshot.
    this.headerEl = document.querySelector('.section-header');
    // --announcement-bar-height: added 2026-07-16 when the announcement bar joined
    // the pinned sticky stack (see sections/header.liquid and
    // sections/announcement-bar.liquid) — same staleness risk, same fix.
    this.announcementEl = document.querySelector('.announcement-bar-section');

    if ('ResizeObserver' in window) {
      if (this.headerEl) {
        this.headerResizeObserver = new ResizeObserver((entries) => {
          const height = entries[0].contentRect.height;
          document.documentElement.style.setProperty('--header-height', `${height}px`);
        });
        this.headerResizeObserver.observe(this.headerEl);
      }

      if (this.announcementEl) {
        this.announcementResizeObserver = new ResizeObserver((entries) => {
          const height = entries[0].contentRect.height;
          document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
        });
        this.announcementResizeObserver.observe(this.announcementEl);
      }

      // --sunshine-toolbars-height: added 2026-07-17 for the bottom-nav Styles/Colors
      // anchor-jump links (snippets/bottom-nav.liquid) — their targets set
      // scroll-margin-top from announcement + header + this toolbar's own height, so
      // the jump lands below the pinned sticky stack instead of underneath it.
      this.toolbarsResizeObserver = new ResizeObserver((entries) => {
        const height = entries[0].contentRect.height;
        document.documentElement.style.setProperty('--sunshine-toolbars-height', `${height}px`);
      });
      this.toolbarsResizeObserver.observe(this);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('sunshine:header-state', this.onNavState);
    if (this.headerResizeObserver) {
      this.headerResizeObserver.disconnect();
    }
    if (this.announcementResizeObserver) {
      this.announcementResizeObserver.disconnect();
    }
    if (this.toolbarsResizeObserver) {
      this.toolbarsResizeObserver.disconnect();
    }
  }

  onNavState(event) {
    const { compact, hidden } = event.detail || {};

    if (typeof compact === 'boolean') {
      this.classList.toggle('sunshine-toolbars--compact', compact);
    }

    if (typeof hidden === 'boolean') {
      this.classList.toggle('sunshine-toolbars--header-hidden', hidden);
    }
  }
}

customElements.define('sunshine-toolbars', SunshineToolbars);
